export const getDomainOfUrl = (url: string) => {
  try {
    const realUrl = new URL(url);
    const { hostname } = realUrl;
    const hostnameParts = hostname.split('.');
    hostnameParts.pop();

    return hostnameParts.join('').replace('www', '');
  } catch (error) {
    return url;
  }
};

export const getHash = () =>
  typeof window !== 'undefined' ? window.location.hash : undefined;
